module.exports = __webpack_public_path__ + "static/media/nabeel4.e83c43d9.svg";